import '../styles/navigation.scss'
import { CmsLinkComponent } from '@omnia/ui/src/lib'
import { observer } from 'mobx-react'
import type { FC } from 'react'
import { NavLink } from '@/common/components/navLink/NavLink'
import { cmsDataService } from '@/common/services/cms.data.service'
import { useMobileNav } from '@/features/layout/hooks/useMobileNav'
import { navigationMenuStore } from '@/features/layout/stores/navigationMenu.store'

export const Navigation: FC = observer(() => {
    const navigation = cmsDataService.get().header.navigation
    const { toggleMobileNav } = useMobileNav()

    const {
        mainNavigation = [],
        mobileNavigationFooterTitle = undefined,
        mobileNavigationFooterLinks = [],
    } = navigation

    return (
        <>
            <input
                type="checkbox"
                id="nav-toggle"
                checked={navigationMenuStore.isNavVisible}
                onChange={toggleMobileNav}
            />
            <label htmlFor="nav-toggle" className="nav-burger" aria-label="Toggle Navigation Menu" />
            <nav>
                <ul className="nav-links">
                    {mainNavigation?.map(navItem => (
                        <li key={navItem.name}>
                            <NavLink link={navItem} onClick={toggleMobileNav} />
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="mobile-nav-footer">
                {mobileNavigationFooterTitle && <h5>{mobileNavigationFooterTitle}</h5>}
                <span className="mobile-nav-footer__links">
                    {mobileNavigationFooterLinks.map(link => (
                        <CmsLinkComponent key={link.name} link={link} />
                    ))}
                </span>
            </div>
        </>
    )
})
